import "./About.module.css";
import Header from "@/reusable_sections/Header";
import OurHistory from "./sections/OurHistory";
import MeetTheTeam from "./sections/MeetTheTeam";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <OurHistory />
      <MeetTheTeam />
      <Footer />
    </div>;
}